import { p as polyfill } from './polyfill.js';
import { d as defineProperties_1 } from '../define-properties/index.js';

var getPolyfill = polyfill;
var define = defineProperties_1;

var shim = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

export { shim as s };
